import script from "./LocationsView.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationsView.vue?vue&type=script&setup=true&lang=js"

import "./LocationsView.vue?vue&type=style&index=0&id=63c3a8c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c3a8c9"]])

export default __exports__